import { Text, Token, View } from "@ctv/shared-core/src";
import { ReactNode } from "react";
import { StyleSheet } from "react-native";

type TextProps = {
  label?: string;
  value?: ReactNode;
};

export default function ReviewRow(props: TextProps) {
  const { label, value = "-" } = props;

  return (
    <View row align="center" style={styles.wrapper}>
      <Text variant="title-2" style={styles.label}>
        {label}
      </Text>
      {typeof value === "string" && (
        <Text variant="ui-baseline" ink="black-secondary">
          {value || "-"}
        </Text>
      )}
      {typeof value === "object" && <View style={styles.element}>{value}</View>}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    paddingHorizontal: Token.spacing.l,
    paddingVertical: Token.spacing.m,
  },
  label: {
    width: 175,
    marginRight: Token.spacing.xxxl,
  },
  element: {
    flex: 1,
  },
});
